import React from 'react';

import rtlService from '../../services/app/rtlService';
import Icon from '../Icon/Icon';

const UsageWeeklyIcon = (props) => {
    const isRTLEnabled = rtlService.isRtlEnabled();

    return (
        <Icon width='64' height='64' {...props}>
            <g fill='none' fillRule='evenodd'>
                <path
                    d='M34.906 45.5H21a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v5.344c-3.051.108-5.522 1.16-7.412 3.156-1.89 1.996-2.785 4.496-2.682 7.5z'
                    fill='#E1E0E2'
                />
                <path
                    d='M35.896 49H17a2 2 0 0 1-2-2V17a2 2 0 0 1 2-2h24a8 8 0 0 1 8 8v12.925'
                    stroke='#34303D'
                    strokeWidth='2'
                    strokeLinejoin='round'
                />
                <g transform='translate(21 30)'>
                    <rect fill='#34303D' width='4' height='3' rx='1' />
                    <rect fill='#34303D' x='6' width='4' height='3' rx='1' />
                    <rect fill='#34303D' x='12' width='4' height='3' rx='1' />
                    <rect fill='#34303D' x='18' width='4' height='3' rx='1' />
                    <rect fill='#FFFDFB' y='5' width='4' height='3' rx='1' />
                    <rect fill='#FFFDFB' x='6' y='5' width='4' height='3' rx='1' />
                    <rect fill='#FFFDFB' x='12' y='5' width='4' height='3' rx='1' />
                    <path d='M18 7V6a1 1 0 0 1 1-1h2' fill='#FFFDFB' />
                    <rect fill='#FFFDFB' y='10' width='4' height='3' rx='1' />
                    <rect fill='#FFFDFB' x='6' y='10' width='4' height='3' rx='1' />
                    <path d='M14 13h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2' fill='#FFFDFB' />
                    <rect fill='#FFFDFB' x='18' y='10' width='4' height='3' rx='1' />
                    <path
                        d='M24.034 7.587a7.447 7.447 0 0 1 7.446 7.448 7.444 7.444 0 0 1-7.446 7.445 7.447 7.447 0 0 1 0-14.893'
                        fill='#E1E0E2'
                    />
                    <text
                        fontFamily='IQOS-Bold, IQOS'
                        fontSize='10'
                        fontWeight='bold'
                        letterSpacing='.167'
                        fill='#34303D'
                        style={{transform: isRTLEnabled ? 'translate(42%, 30%)' : 'translate(33%, 30%)'}}
                    >
                        <tspan>7</tspan>
                    </text>
                    <path
                        d='M24 5.692c-5.132 0-9.308 4.175-9.308 9.31 0 5.131 4.176 9.306 9.308 9.306 5.133 0 9.308-4.175 9.308-9.307 0-5.134-4.175-9.309-9.308-9.309zM24 26c-6.065 0-11-4.935-11-10.999C13 8.935 17.935 4 24 4c6.066 0 11 4.935 11 11.001C35 21.065 30.066 26 24 26z'
                        fill='#34303D'
                    />
                </g>
                <path stroke='#34303D' strokeWidth='2' strokeLinecap='square' d='M15.125 23.225h33.3' />
            </g>
        </Icon>
    );
};

export default UsageWeeklyIcon;
